import React from 'react';

import GridContainer from '../../mui-components/Grid/GridContainer';
import ItemGrid from '../../mui-components/Grid/GridItem';
import RegularCard from '../../mui-components/Card/RegularCard';
import MySpreadsheetIncomesTable from '../../containers/domain/spreadsheet-income/MySpreadsheetIncomesTable';

const SpreadsheetIncomesListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Minhas receitas"
        content={<MySpreadsheetIncomesTable />}
      />
    </ItemGrid>
  </GridContainer>
);

export default SpreadsheetIncomesListingView;
